import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1000px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .filter {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    align-items: flex-start;
  }
`;

export const Table = styled.table`
  width: calc(100% - 15px);
  margin-top: 25px;
  border: none;
  border-collapse: separate;
  color: #001b22;
  border-spacing: 0 1em;

  thead {
    tr {
      td {
        padding: 0 15px;
      }
    }
  }

  tbody {
    tr {
      td {
        color: #001b22;
        font-size: 14px;
        height: 40px;
        padding: 0 15px;
        background: #f0f0f0;

        a {
          margin: 10px;
        }

        &:first-child {
          border-bottom-left-radius: 5px;
          border-top-left-radius: 5px;
        }

        &:last-child {
          text-align: center;
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }
      }
    }
  }
`;

export const InputFilter = styled.input`
  padding: 8px;
  border-radius: 5px;
  background-color: #f0f0f0;
  color: #000c;
  height: 40px;
  width: 100%;
  max-width: 450px;
  border: none;
  font-size: 16px;
`;

export const Boxs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 5px 0 10px 0;

  div {
    background: #f0f0f0;
    min-width: 180px;
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    border-radius: 50px;
    justify-content: center;
    margin: 0 15px 10px 0;
    padding: 12px 20px;

    border-width: 2.5px;
    border-color: #fff;
    border-style: solid;
    cursor: pointer;

    &.active {
      border-color: #363636;
    }

    p {
      width: 100%;
      font-size: 13px;
      text-align: center;
      font-weight: 600;
      color: #000;
    }
  }
`;
